// DIN ISO 2768 Allgemeintoleranzen. Gemeinsame Datenbasis für die App
// (src/utils/calculations.js) und die Landing (Build kopiert die Datei
// nach infra/landing/assets/iso2768.js). Bewusst ohne Imports.

// Teil 1, Längenmaße außer gebrochenen Kanten: Bereiche „0,5 bis 3“,
// „über 3 bis 6“ … „über 2000 bis 4000“ mm; null = nicht festgelegt („–“).
export const ISO2768_1_GRENZEN = [3, 6, 30, 120, 400, 1000, 2000, 4000];
export const ISO2768_1_DATA = {
  f: [0.05, 0.05, 0.1, 0.15, 0.2, 0.3, 0.5, null],
  m: [0.1, 0.1, 0.2, 0.3, 0.5, 0.8, 1.2, 2],
  c: [0.2, 0.3, 0.5, 0.8, 1.2, 2, 3, 4],
  v: [null, 0.5, 1, 1.5, 2.5, 4, 6, 8],
};

// Teil 1, gebrochene Kanten (Rundungen, Fasen): „0,5 bis 3“, „über 3 bis 6“, „über 6“.
export const KANTEN_GRENZEN = [3, 6, Infinity];
export const KANTEN = { f: [0.2, 0.5, 1], m: [0.2, 0.5, 1], c: [0.4, 1, 2], v: [0.4, 1, 2] };

// Teil 1, Winkelmaße nach Länge des kürzeren Schenkels: „bis 10“ … „über 400“ mm,
// Grenzabmaße in Bogenminuten (60 = ±1°).
export const WINKEL_GRENZEN = [10, 50, 120, 400, Infinity];
export const WINKEL_MINUTEN = {
  f: [60, 30, 20, 10, 5], m: [60, 30, 20, 10, 5],
  c: [90, 60, 30, 15, 10], v: [180, 120, 60, 30, 20],
};

// Teil 2, Form und Lage (Toleranzwerte in mm).
export const ISO2768_2_DATA = {
  straightness: {
    ranges: [10, 30, 100, 300, 1000, 3000],
    H: [0.02, 0.05, 0.1, 0.2, 0.3, 0.4],
    K: [0.05, 0.1, 0.2, 0.4, 0.6, 0.8],
    L: [0.1, 0.2, 0.4, 0.8, 1.2, 1.6]
  },
  perpendicularity: {
    ranges: [100, 300, 1000, 3000],
    H: [0.2, 0.3, 0.4, 0.5],
    K: [0.4, 0.6, 0.8, 1.0],
    L: [0.6, 1.0, 1.5, 2.0]
  },
  symmetry: {
    ranges: [100, 300, 1000, 3000],
    H: [0.5, 0.5, 0.5, 0.5],
    K: [0.6, 0.8, 1.0, 1.2],
    L: [0.6, 1.0, 1.5, 2.0]
  },
  runout: { H: 0.1, K: 0.2, L: 0.5 }
};
